module.exports = __webpack_public_path__ + "static/media/boston-stir.6fbef240.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2016-11-10/boston-stir.jpg
// module id = 796
// module chunks = 0